<template>
  <PageContainer title="Dashboard">
    <Box space="medium" class="main-container">
      <div class="cards">
        <ClassesCard title="Teóricos em processamento" :value="theoryAwaitingProcessing.value"
          @download="exportClassTheoryAwaitingProcessing">
          <SchoolOutline slot="icon" :size="45" />
        </ClassesCard>

        <ClassesCard title="Teóricas rejeitadas" :value="theoryPending.value" color="red"
          @download="exportClassTheoryPending">
          <CloseCircleOutline slot="icon" :size="45" />
        </ClassesCard>

        <ClassesCard title="Práticas rejeitadas" :value="practicalPending.value" color="orange"
          @download="exportClassPracticalPending">
          <Steering slot="icon" :size="45" />
        </ClassesCard>
      </div>

      <AulasGraphic />
    </Box>

    <NotificationsSection />

    <PendenciasPraticasGraphic />

    <a href="#" hidden id="downloadCSV"></a>
  </PageContainer>
</template>

<script>
import Box from 'core/Box'
import PageContainer from 'core/PageContainer'

import CloseCircleOutline from 'icons/CloseCircleOutline'
import SchoolOutline from 'icons/SchoolOutline'
import Steering from 'icons/Steering'

import ClassesCard from './ClassesCard'

import * as spinners from 'epic-spinners'
import AulasGraphic from './AulasGraphic'
import DashboardController from './DashboardController'
import PendenciasPraticasGraphic from './PendenciasPraticasGraphic'
import { ordersChart } from './charts/Chart'
import NotificationsSection from '../../dashboard/NotificationsSection.vue'

export default {
  components: {
    PageContainer,
    Box,

    SchoolOutline,
    CloseCircleOutline,
    Steering,

    ClassesCard,

    ...spinners,
    AulasGraphic,
    PendenciasPraticasGraphic,
    NotificationsSection,
  },

  data() {
    return {
      salesChartID: 'salesChart',
      ordersChartID: 'ordersChart',
      theoryAwaitingProcessing: {
        value: 0,
        load: false,
        progress: 0,
        state: false,
      },
      theoryPending: {
        value: 0,
        load: false,
        progress: 0,
        state: false,
      },
      practicalPending: {
        value: 0,
        load: false,
        progress: 0,
        state: false,
      },
    }
  },

  methods: {
    getClassTheoryAwaitingProcessing() {
      this.theoryAwaitingProcessing.load = true
      DashboardController.getClassTheoryAwaitingProcessing(response => {
        this.theoryAwaitingProcessing.value = response
        this.theoryAwaitingProcessing.load = false
      })
    },
    getClassTheoryPending() {
      this.theoryPending.load = true
      DashboardController.getClassTheoryPending(response => {
        this.theoryPending.value = response
        this.theoryPending.load = false
      })
    },
    getClassPracticalPending() {
      this.practicalPending.load = true
      DashboardController.getClassPracticalPending(response => {
        this.practicalPending.value = response
        this.practicalPending.load = false
      })
    },
    exportClassPracticalPending() {
      this.practicalPending.state = true
      if (this.practicalPending.state === true) {
        setInterval(() => {
          if (this.practicalPending.progress < 100) {
            this.practicalPending.progress += 5
          } else {
            this.practicalPending.progress = 0
          }
        }, 500)
      }

      this.launchToast('Baixando planilha de aulas práticas pendentes...')
      DashboardController.exportClassPracticalPending(response => {
        var csv = 'data:text/csv;charset=utf-8,' + response
        var dlnk = document.getElementById('downloadCSV')
        dlnk.download = 'aulas_praticas_pendentes.csv'
        dlnk.href = csv
        dlnk.click()
        this.practicalPending.state = false
      })
    },
    exportClassTheoryPending() {
      this.theoryPending.state = true
      if (this.theoryPending.state === true) {
        setInterval(() => {
          if (this.theoryPending.progress < 100) {
            this.theoryPending.progress += 5
          } else {
            this.theoryPending.progress = 0
          }
        }, 500)
      }
      this.launchToast('Baixando planilha de aulas teóricas pendentes...')
      DashboardController.exportClassTheoryPending(response => {
        var csv = 'data:text/csv;charset=utf-8,' + response
        var dlnk = document.getElementById('downloadCSV')
        dlnk.download = 'aulas_teoricas_pendentes.csv'
        dlnk.href = csv
        dlnk.click()
        this.theoryPending.state = false
      })
    },
    exportClassTheoryAwaitingProcessing() {
      this.theoryAwaitingProcessing.state = true
      if (this.theoryAwaitingProcessing.state === true) {
        setInterval(() => {
          if (this.theoryAwaitingProcessing.progress < 100) {
            this.theoryAwaitingProcessing.progress += 5
          } else {
            this.theoryAwaitingProcessing.progress = 0
          }
        }, 500)
      }

      this.launchToast('Baixando planilha de aulas teóricas processamento...')
      DashboardController.exportClassTheoryAwaitingProcessing(response => {
        var csv = 'data:text/csv;charset=utf-8,' + response
        var dlnk = document.getElementById('downloadCSV')
        dlnk.download = 'aulas_teoricas_em_processamento.csv'
        dlnk.href = csv
        dlnk.click()
        this.theoryAwaitingProcessing.state = false
      })
    },

    launchToast(mensagem) {
      this.$toasted.show(mensagem, {
        position: 'top-right',
      })
    },
  },
  created() {
    this.getClassTheoryAwaitingProcessing()
    this.getClassTheoryPending()
    this.getClassPracticalPending()
    ordersChart.createChart(this.ordersChartID)
  },
}
</script>

<style lang="scss" scoped>
.main-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  .cards {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;

    >div {
      flex: 1;
    }
  }
}
</style>
